// 封装ajax方法
import Axios from 'axios'
import store from 'store'
import {closeLoding} from './mixed'
import Vue from 'vue'
import VueProgressBar from 'vue-progressbar'
import { logout } from 'utils/login-util'
import { SET_TOKEN } from 'utils/constant'
import { cacheAdapterEnhancer, throttleAdapterEnhancer } from 'axios-extensions'

const options = {
  color: '#36d9d1',
  failedColor: '#ed5454',
  thickness: '2px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
}

Vue.use(VueProgressBar, options)

// region 自有 api ajax 请求
const Ajax = Axios.create({
  timeout: 50000,
  withCredentials: true,
  headers: {
    'Access-Ajax': 1
  },
  // ajax 节流加缓存 https://github.com/kuitos/axios-extensions
  adapter: throttleAdapterEnhancer(cacheAdapterEnhancer(Axios.defaults.adapter, false))
})

// request拦截器
Ajax.interceptors.request.use(
  (config) => {
    let token = store.getters.token
    if (!config.noToken && token) {
      config.headers['Access-Token'] = token
    }
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

// response 拦截器
Ajax.interceptors.response.use(
  (response) => {
    store.commit(SET_TOKEN, response.headers['access-token'])
    return response.data
  },
  (error) => {
    if (error.code === 'ECONNABORTED') {
      // Vue.prototype.$awn.warning('请求超时，请重试')
    } else if (error.response.status === 500) {
      if (process.env.NODE_ENV !== 'production') {
        Vue.prototype.$awn.warning(error.response.data.meta.message)
      } else {
        // eslint-disable-next-line no-undef
        fundebug.notify(error)
      }
      return Promise.resolve(error.response.data)
    } else if (error.response.status === 401) {
      logout()
    } else {
      Vue.prototype.$awn.warning(error.response.data.meta.message)
    }
    return Promise.reject(error)
  }
)

// request拦截器
Ajax.interceptors.request.use((config) => {
  Vue.prototype.$Progress.start()
  return config
})

// request拦截器
Ajax.interceptors.response.use((config) => {
  Vue.prototype.$Progress.finish()
  closeLoding()
  return config
}, () => {
  closeLoding()
  Vue.prototype.$Progress.fail()
})
// endregion

// region 站外 ajax 请求
const OutAjax = Axios.create({
  timeout: 10000
})

// request拦截器
OutAjax.interceptors.request.use((config) => {
  Vue.prototype.$Progress.start()
  return config
})

// request拦截器
OutAjax.interceptors.response.use((config) => {
  closeLoding()
  Vue.prototype.$Progress.finish()
  return config
}, () => {
  closeLoding()
  Vue.prototype.$Progress.fail()
})
// endregion

export { Ajax, OutAjax }



// WEBPACK FOOTER //
// ./src/common/utils/ajax-base.js